import { createUseStyles } from 'react-jss'

import { COLOR, MQ, TYPOGRAPHY } from 'utils/constants'

export const useStyles = createUseStyles({
  wrapper: {
    display: 'flex',
    padding: [30, 0, 30, 0],
    borderBottom: `2px solid ${COLOR.LIGHT_GREEN}`,
    alignItems: 'center',
    [MQ.DESKTOP]: {
      padding: [50, 0, 40, 0],
    },
  },
  imageLink: {
    width: '35%',
    [MQ.TABLET]: {
      width: 'unset',
    },
    [MQ.TABLET_LARGE]: {
      width: 'unset',
    },
  },
  image: {
    borderRadius: 8,
  },
  productDetails: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 10,
    [MQ.TABLET]: {
      marginLeft: 0,
      width: 250,
    },
    '& p': {
      marginBottom: 5,
    },
  },
  title: {
    margin: [0, 10],
    textTransform: 'uppercase',
    color: COLOR.DARK_GREEN,
    marginBottom: 0,
    [MQ.TABLET]: {
      margin: [0, 20],
    },
  },
  productOptions: {
    display: 'flex',
    margin: [0, 0, 0],
  },
  option: {
    margin: [0, 10],
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [MQ.TABLET]: {
      margin: [0, 20],
    },
  },
  optionValue: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    border: `3px solid ${COLOR.LIGHT_GREEN}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: COLOR.DARK_GREEN,
    '& span': {
      fontWeight: 400,
    },
  },
  productControls: {
    margin: [10, 10, 0],
    [MQ.TABLET]: {
      margin: [25, 10, 0],
    },
  },
  control: {
    textDecoration: 'underline',
    textDecorationColor: COLOR.LIGHT_GREEN,
    color: COLOR.DARK_GREEN,
  },
  controlButton: {
    backgroundColor: 'transparent',
    padding: 0,
    border: 'none',
    outline: 'none',
    margin: [0, 10],
    cursor: 'pointer',
    [MQ.TABLET]: {
      margin: [0, 10],
    },
  },
  editSelect: {
    position: 'relative',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& select': {
      ...TYPOGRAPHY.PROXIMA_NOVA,
      fontSize: 16,
      lineHeight: 1,
      fontWeight: 400,
      borderRadius: 8,
      border: `none`,
      height: '100%',
      color: COLOR.DARK_GREEN,
      outline: 'none',
      backgroundColor: COLOR.WHITE,
      WebkitAppearance: 'none',
      padding: 5,
      cursor: 'pointer',
      minWidth: 30,
      [MQ.TABLET_LARGE]: {
        fontSize: 16,
      },
    },
    '&:after': {
      content: "''",
      width: 5,
      height: 5,
      borderLeft: `2px solid ${COLOR.DARK_GREEN}`,
      borderBottom: `2px solid ${COLOR.DARK_GREEN}`,
      transform: 'translateY(-20%) rotate(-45deg)',
      pointerEvents: 'none',
    },
  },
  editInput: {
    minWidth: 30,
  },
  editField: {
    ...TYPOGRAPHY.PROXIMA_NOVA,
    fontSize: 16,
    lineHeight: 1,
    fontWeight: 400,
    borderRadius: 8,
    border: `3px solid ${COLOR.LIGHT_GREEN}`,
    height: '100%',
    color: COLOR.DARK_GREEN,
    outline: 'none',
    backgroundColor: COLOR.WHITE,
    WebkitAppearance: 'none',
    padding: 5,
    [MQ.TABLET_LARGE]: {
      fontSize: 16,
    },
    [`@media not all and (min-resolution:0.01dpcm)`]: {
      [`@supports (-webkit-appearance: none)`]: {
        padding: 5,
      },
    },
  },
  // leftColumn: {
  //   marginLeft: 'auto',
  //   display: 'flex',
  //   flexDirection: 'column',
  //   justifyContent: 'space-between',
  //   alignItems: 'flex-end',
  // },
  // deleteButton: {
  //   padding: 0,
  //   width: 25,
  //   height: 25,
  //   backgroundColor: 'transparent',
  //   border: 'none',
  //   outline: 'none',
  //   cursor: 'pointer',
  // },
  // x: {
  //   width: '100%',
  //   height: '100%',
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  //   position: 'relative',
  //   '&:before': {
  //     content: `''`,
  //     width: '100%',
  //     height: 2,
  //     backgroundColor: COLOR.DARK_GREEN,
  //     transform: 'rotate(-45deg)',
  //     position: 'absolute',
  //   },
  //   '&:after': {
  //     content: `''`,
  //     width: '100%',
  //     height: 2,
  //     backgroundColor: COLOR.DARK_GREEN,
  //     transform: 'rotate(45deg)',
  //     position: 'absolute',
  //   },
  // },
})
